import type { CrawlerNames } from "./types.ts";

// Crawlers that drive the initial crawl UI (modal + header widget). Only include crawlers whose
// completion is meaningful to surface to the user as part of the first-scan experience.
//
// This list also guards against showing a false "initializing" state when releasing a new crawler:
// tenants are backfilled in the background before the feature goes live, so a crawler is only added
// here once it is fully released and all existing tenants have already been crawled.
export const initialCrawlerNames = [
    "archivedSiteCollections",
    "groups",
    "permissions",
    "securityGroups",
    "sensitivityLabels",
    "sharePointGroups",
    "siteActivity",
    "siteSettings",
    "tenantLicenses",
    "tenantSettings",
    "users"
] as const satisfies readonly CrawlerNames[];

// Crawlers that gate polling. Includes enrichment crawlers that don't affect the initial crawl UI
// but should still trigger table refreshes when their state changes.
export const releasedCrawlerNames: readonly CrawlerNames[] = [...initialCrawlerNames, "permissionsEnrichment"];
